import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@/../environments/environment';
import { TipoCota, TipoCotaRequest } from '@/models';
import { PageResponse, StatusCount } from './pagination.types';

@Injectable({
  providedIn: 'root',
})
export class TipoCotaService {
  private baseUrl = `${environment.apiUrl}/admin/tipos-cotas`;

  constructor(private http: HttpClient) {}

  getTiposCotas(): Observable<TipoCota[]> {
    return this.http.get<TipoCota[]>(this.baseUrl);
  }

  getTipoCota(id: number): Observable<TipoCota> {
    return this.http.get<TipoCota>(`${this.baseUrl}/${id}`);
  }

  createTipoCota(data: TipoCotaRequest): Observable<TipoCota> {
    return this.http.post<TipoCota>(this.baseUrl, data);
  }

  updateTipoCota(id: number, data: TipoCotaRequest): Observable<TipoCota> {
    return this.http.put<TipoCota>(`${this.baseUrl}/${id}`, data);
  }

  deleteTipoCota(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }

  toggleStatus(id: number, active: boolean): Observable<TipoCota> {
    return this.http.patch<TipoCota>(`${this.baseUrl}/${id}/toggle-status`, { active });
  }

  /**
   * Lista tipos de cotas paginados
   * GET /api/admin/tipos-cotas/paginado
   */
  listarPaginado(
    page: number = 0,
    size: number = 10,
    sortBy: string = 'nome',
    sortDirection: 'ASC' | 'DESC' = 'ASC',
    apenasAtivos?: boolean
  ): Observable<PageResponse<TipoCota>> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString())
      .set('sortBy', sortBy)
      .set('sortDirection', sortDirection);
    
    if (apenasAtivos !== undefined) {
      params = params.set('apenasAtivos', apenasAtivos.toString());
    }
    
    return this.http.get<PageResponse<TipoCota>>(`${this.baseUrl}/paginado`, { params });
  }

  /**
   * Obtém contagem de status dos tipos de cotas
   * GET /api/admin/tipos-cotas/status
   */
  getStatus(): Observable<StatusCount> {
    return this.http.get<StatusCount>(`${this.baseUrl}/status`);
  }
}
